import { render, staticRenderFns } from "./Correlation.vue?vue&type=template&id=49b15810&"
import script from "./Correlation.vue?vue&type=script&lang=js&"
export * from "./Correlation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports